import { render, staticRenderFns } from "./advType.vue?vue&type=template&id=a62f3618"
import script from "./advType.vue?vue&type=script&lang=js"
export * from "./advType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports